import { css, Flex, styled } from '@chilipiper/design-system'

export const StyledAvatarImage = styled.img<{ borderWidth: string }>`
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
  border: ${({ borderWidth }) => borderWidth} solid #161b25;
`

export const StyledOverflowFlex = styled(Flex)`
  scrollbar-gutter: stable;
  overflow: hidden auto;
  overscroll-behavior: contain;
`

export const stylesChatLinks = css`
  a {
    color: rgb(var(--primary-color));
    box-shadow: inset 0px -2px 0px rgba(var(--primary-color), 0.12);
  }
`
